export const viewportBreakpoints = Object.freeze({
	xs: 0,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
	xxl: 1600,
	compactShortSide: 600,
});

export const getViewportLayout = ({ width, height, ...dimensions }) => {
	let size = 'lg';
	if( width < viewportBreakpoints.sm ) {
		size = 'xs';
	} else if( width < viewportBreakpoints.md ) {
		size = 'sm';
	} else if( width < viewportBreakpoints.lg ) {
		size = 'md';
	}
	return {
		...dimensions,
		width,
		height,
		size,
		isSmallDevice: width < viewportBreakpoints.md,
		isCompactDevice: Math.min( width, height ) < viewportBreakpoints.compactShortSide,
		isLandscape: width > height,
	};
};
